import ApiService from '../common/api.service'

class DocumentsService extends ApiService {

  /**
   * Get documents to treat
   * @param {String} semail semail to verify
   */
  getUntreatedDocuments () {
    return this.get(`/user/legalDocuments/consents`).then((res) => { return Promise.resolve(res.data) })
  }
  /**
   * Send consents to document
   * @param {String} semail semail to verify
   * @param {Array<number>} documentIds documents IDs to consents
   */
  sendDocumentConsent (documentIds) {
    return this.put(`/user/legalDocuments/consents`, documentIds).then((res) => { return Promise.resolve(res.data) })
  }

}

export default DocumentsService



// WEBPACK FOOTER //
// ./src/app/services/documents/documents.service.js